<template>
  <v-autocomplete
    :loading="loading"
    :value="value"
    :items="countries"
    :label="$t('SIGNUP.COUNTRY')"
    @input="$emit('input', $event)"
    item-value="id"
    item-text="name"
    name="tk_country_select"
    browser-autocomplete="off"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const handler = new ErrorHandler();
const countriesRepo = RepositoryFactory.countries();

export default {
  props: ["value"],

  data() {
    return {
      loading: false,
      model: null,
      countries: []
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.$emit("loading", true);
      await handler.handle(async () => {
        this.countries = await countriesRepo.getCountries();
      });
      this.loading = false;
      this.$emit("loading", false);
      this.$emit("loadingEnded", this.countries);
    }
  }
};
</script>

<style lang="scss">
.v-autocomplete.v-input > .v-input__control > .v-input__slot  {
  cursor: pointer;
}
</style>